import { GroupProp } from "../../../../components/form-factory/utils/util";
import { UserProps } from "../../../../../domain/models/user";

export const Fields = (
  data: UserProps | undefined,
  edit?: boolean,
): GroupProp[] => [
    {
      groupName: "TOMADOR",
      groupLabel: "Dados:",
      items: [
        {
          name: "name",
          type: "text",
          label: "Nome:",
          validations: "inputRequired",
          defaultValue: data?.name,
          disabled: !edit,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "email",
          type: "text",
          label: "Email:",
          validations: "inputRequired",
          defaultValue: data?.email,
          disabled: !edit,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        }
      ],
    }
  ];